import React, { lazy } from 'react';
import IconBattery from '@/assets/images/menu/icon-battery.react.svg?react';
import { CapitalPlatform } from '@/infrastructure/utils/app';
import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

export const powerRoutes = (): IRouteConfig[] => [
  {
    path: '/battery',
    name: '电量',
    icon: <MenuIcon icon={IconBattery} fontSize={16} />,
    platforms: [
      CapitalPlatform.Android,
    ],
    sort: 89,
    routes: [
      {
        path: '/battery/analytics',
        name: '指标分析',
        component: lazy(() => import('@/presentation/pages/battery/analytics')),
      },
      {
        path: '/battery/factor',
        name: '耗电因素',
        component: lazy(() => import('@/presentation/pages/battery/factor')),
      },
      {
        path: '/battery/issues/detail',
        name: '异常详情',
        component: lazy(() => import('@/presentation/pages/battery/issues/detail')),
        hideInMenu: true,
        whitelisted: true,
      },
      {
        path: '/battery/issues',
        name: '异常分析',
        component: lazy(() => import('@/presentation/pages/battery/issues/list')),
      },
    ],
  },
];

export default powerRoutes;
